<template>
  <vx-card heading-size="h1" title="Edit Student">
    <!-- Info -->
    <vs-input
      class="w-full mb-base"
      label-placeholder="First Name"
      v-model="fname"
      v-validate="'required'"
    ></vs-input>
    <span class="text-danger text-sm" v-show="errors.has('fname')">{{
      errors.first('fname')
    }}</span>
    <vs-input class="w-full mb-base" label-placeholder="Last Name" v-model="lname"></vs-input>
    <vs-input class="w-full mb-base" label-placeholder="Email" v-model="email"></vs-input>
    <vs-input
      type="password"
      class="w-full mb-base"
      label-placeholder="Password"
      v-model="password"
    ></vs-input>
    <vs-input
      type="password"
      class="w-full mb-3"
      label-placeholder="Confirm Password"
      v-model="password_confirmation"
    ></vs-input>
    <select class="defaultselect w-full mb-base" v-model="year" aria-label="Year Group">
      <option
        :key="index"
        :value="item.id"
        v-for="(item, index) in student_groups"
        :selected="item.id == year"
      >
        {{ item.name }}
      </option>
    </select>
    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <form @submit.prevent="submitForm">
        <button class="btn btn-primary btn-size-medium ml-auto mt-2" button="submit">
          Save Changes
        </button>
      </form>

      <vs-alert
        class="mt-5"
        :color="alertStatus"
        :title="alertTitle"
        active="true"
        v-if="showAlert"
      >
        <span v-html="alertMessage"></span>
      </vs-alert>
    </div>
  </vx-card>
</template>

<script>
import studentMixin from '@/mixins/student';
import theApi from '@/mixins/theApi';
import store from '@/store/store';

export default {
  computed: {
    teacherAccessType() {
      return store.getters['authTeacher/accessType'];
    },
  },
  data() {
    return {
      student_groups: studentMixin.methods.getGroups(),
      fname: '',
      lname: '',
      email: '',
      password: '',
      password_confirmation: '',
      year: '',
      showAlert: false,
      alertStatus: 'success',
      alertMessage: '',
      alertTitle: 'Success',
    };
  },
  methods: {
    async getData() {
      const student_id = this.$route.params.student_id;

      theApi.methods.makeCall(true, 'students/get/' + student_id, 'post', null, true).then(
        (data) => {
          this.fname = data.student_name;
          this.lname = data.student_surname;
          this.email = data.student_email;
          this.year = data.student_group;
        },
        () => {},
      );
    },
    async submitForm() {
      const student_id = this.$route.params.student_id;
      const formData = new FormData();
      formData.append('student_name', this.fname);
      formData.append('student_surname', this.lname);
      formData.append('student_email', this.email);
      formData.append('password', this.password);
      formData.append('password_confirmation', this.password_confirmation);
      formData.append('student_group', this.year);

      theApi.methods
        .makeCall(
          false,
          'students/save/' + student_id,
          'post',
          formData,
          'Student saved successfully.',
          true,
        )
        .then(
          () => {},
          () => {},
        );
    },
  },
  mounted() {
    if (this.teacherAccessType != 2) {
      this.$router.push('/teacher/dashboard');
    } else {
      this.getData();
    }
  },
  mixins: [studentMixin],
};
</script>
